import React from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';
import {useTranslation} from "react-i18next";

function Footer() {
    const { t } = useTranslation();

    return (
            <div className='footer-container'>
                <div className='footer-links'>
                    <div className='footer-link-wrapper'>
                        <div className='footer-link-items'>
                            <Link to='/company'><h2>About Us</h2></Link>
                            <Link to='/company'>Our Services</Link>
                            <Link to='/terms-of-use'>{t('Terms of Use')}</Link>
                            <Link to='/privacy-policy'>{t('Privacy Policy')}</Link>
                        </div>
                        <div className='footer-link-items'>
                            <Link to='/video-section'><h2>Video Section</h2></Link>
                            <Link to='/video-section'>Projects in Progress</Link>
                            <Link to='/testimonials'>Testimonials</Link>
                        </div>
                        <div className='footer-link-items'>
                            <h2>Social Media</h2>
                            <div>Instagram</div>
                            <div>Facebook</div>
                            <div>Youtube</div>
                        </div>
                    </div>
                </div>
                <div className="footer-bottom">
                    <div className="copyright">© Copyright 2025 Abougabal Constructions | All Rights Reserved</div>
                    <div className="signature">Engineered by BillieM.</div>
                </div>
            </div>
    );
}

export default Footer;
